import { render } from "./DetailsHeader.vue?vue&type=template&id=a3179086"
import script from "./DetailsHeader.vue?vue&type=script&lang=js"
export * from "./DetailsHeader.vue?vue&type=script&lang=js"

import "./DetailsHeader.vue?vue&type=style&index=0&id=a3179086&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__